<template lang="pug">
main
  .col-md-12.hexagon-container-mobile
    itemMobile(v-for="(o, index) in listItems()", 
      :title="o.name", 
      :key="o.id", 
      :id="o.id", 
      :index="index" 
      :isSelected="o.selected", 
      @onListSelect="onListSelected")
</template>

<script>
import ItemMobile from './itemMobile'

export default {
  components: {
    ItemMobile
  },
  props: {
    lstItemsMobile: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      filterItems: []
    }
  },
  methods: {
    onListSelected(index) {
      // console.log('Item selected beehive ' + this.filterItems[index].name)
      var selItemMobile = this.filterItems[index]
      selItemMobile.selected = !selItemMobile.selected
      this.$set(this.filterItems, index, selItemMobile)
      this.$emit('onlstItemsMobile', this.filterItems)
    },
    listItems() {
      if (this.lstItemsMobile && this.lstItemsMobile.length > 0) {
        var temp = []
        var index = 1000
        for (var i = 1; i <= this.lstItemsMobile.length; i++) {
          temp.push(this.lstItemsMobile[i - 1])
          if (i % 7 === 0) {
            temp.push({id: index})
            index++
          }
        }
        if (temp) this.filterItems = temp
        return temp
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BeeHiveMobile.vue?00115134